import React from 'react';
import PropTypes from 'prop-types';
import autobind from "autobind-decorator";
import { connect } from 'react-redux';

import { Component, Loading } from 'core/components';
import { SwiperSlide, Swiper } from 'core/components/Framework7';
import { addToCart, changeCountItem, deleteItem } from 'content/pages/Cart/Module';
import { ProductItem } from 'content/components';
import classes from './styles.module.css';

class ProductSwiper extends Component {
  constructor(props) {
    super(props);

    this.state = {}
  }

  static get defaultProps() {
    return {
      items: [],
      item: null,
      value: null,
      img: null,
      icon: null,
      navigation: true,
      swiper: {
        speed: 300,
        slidesPerView: 'auto',
        spaceBetween: 0,
        resistance: false,
        resistanceRatio: 0,
        freeModeMomentumRatio: .5,
        freeModeSticky: true,
        freeMode: true,
        preloadImages: false,
      },
    }
  }

  renderEmpty() {
    return (
      <div className={classes.empty}>آیتمی جهت نمایش وجود ندارد</div>
    )
  }

  renderSwiperItems() {
    const { items } = this.props;

    if (!items) return this.renderEmpty()

    return items.map(item => {
      return this.renderSwiperItem(item)
    })
  }

  renderSwiperItem(item) {
    const { img, icon, navigate } = this.props;

    return (
      <SwiperSlide
        key={item.id}
        className={classes.swiperSlide}
      >
        <ProductItem
          item={item}
          img={img}
          icon={icon}
          navigate={navigate}
        />
      </SwiperSlide>
    )
  }

  render() {
    const { swiper, navigation, loading } = this.props;

    return (
      loading ?
        <Loading height={38} />
        :
        <Swiper
          params={swiper}
          navigation={navigation}
          className={classes.swiper}
        >
          {this.renderSwiperItems()}
        </Swiper>
    )
  }
}

ProductSwiper.propTypes = {
  items: PropTypes.array,
  img: PropTypes.any,
  loading: PropTypes.bool,
  navigation: PropTypes.bool,
  swiper: PropTypes.object
};

export default connect(
  state => ({
    cart: state.Cart.cart
  }),
  {
    addToCart,
    changeCountItem,
    deleteItem
  }
)(autobind(ProductSwiper))
